import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/wechatdown';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getLogs(params: any) {
    return api.getLogs(params);
  }
}
